import { t } from '../i18n/t';
import { kindLabel } from './practice.ts';

/**
 * Declared here rather than imported from a generated artifact.
 *
 * It used to come from `HubDetailMutation.graphql`, which tied this component's
 * types to whichever query happened to exist -- and broke when that mutation was
 * deleted with the practice hub's dead recorder. `%future added value` is
 * Relay's own member, kept so a status from a newer schema still type-checks.
 */
export type PracticeResult = 'RECURRED' | 'TARGETED' | 'USED_CORRECTLY' | '%future added value';
type PracticeItem = {
  kind: string;
};
type PracticeOutcome = {
  outcome: PracticeResult;
  item: PracticeItem;
};
export { PracticeOutcome };
export type PracticeStatsRowProps = {
  kind: string;
  outcomes: PracticeOutcome[];
};
export function PracticeStatsRow({
  kind,
  outcomes
}: PracticeStatsRowProps) {
  const counts: Record<PracticeResult, number> = {
    RECURRED: 0,
    TARGETED: 0,
    USED_CORRECTLY: 0,
    '%future added value': 0
  };
  for (const {
    outcome
  } of outcomes) {
    counts[outcome]++;
  }
  const total = counts.TARGETED + counts.RECURRED + counts.USED_CORRECTLY;
  if (total === 0) return null;
  return (
    // Wrapping, and only the outcomes that happened: three fixed badges were
    // wider than a phone and pushed the whole history sideways.
    <div className="mt-2 flex flex-wrap items-center gap-x-3 gap-y-1">
      <span className="text-xs text-base-content/50">{kindLabel(kind)}</span>
      <div className="flex flex-wrap items-center gap-1">
        {counts.TARGETED > 0 && <span className="badge badge-sm badge-warning badge-outline" title={t('stats-targeted-title', {
          count: counts.TARGETED
        })}>
            {t('stats-targeted', {
            count: counts.TARGETED
          })}
          </span>}
        {counts.RECURRED > 0 && <span className="badge badge-sm badge-error badge-outline" title={t('stats-recurred-title', {
          count: counts.RECURRED
        })}>
            {t('stats-recurred', {
            count: counts.RECURRED
          })}
          </span>}
        {counts.USED_CORRECTLY > 0 && <span className="badge badge-sm badge-primary badge-outline" title={t('stats-used-correctly-title', {
          count: counts.USED_CORRECTLY
        })}>
            {t('stats-used-correctly', {
            count: counts.USED_CORRECTLY
          })}
          </span>}
      </div>
    </div>
  );
}